import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'

import * as lookupReducers from './lookup-reducer';
import * as dataReducers from './data-reducer';

const rootReducer = (history) => combineReducers({
    ...lookupReducers,
    ...dataReducers,
    router: connectRouter(history)
})

rootReducer.propTypes = {
    history: PropTypes.object
}

export default rootReducer